import { useReducer } from "react";

const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalCount: 0,
};

const paginationReducer = (state, action) => {
  switch (action.type) {
    case "SET_PAGE":
      return { ...state, page: action.payload };
    case "SET_ROWS_PER_PAGE":
      return { ...state, rowsPerPage: action.payload, page: 0 };
    case "SET_TOTAL_COUNT":
      return { ...state, totalCount: action.payload };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

const usePaginationReducer = () => {
  const [state, dispatch] = useReducer(paginationReducer, initialState);
  return [state, dispatch];
};

export default usePaginationReducer;
